var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isHeatSelected)?_c('div',{attrs:{"id":"heat-head"}},[_c('div',[_c('div',{staticClass:"event-name"},[_vm._v(_vm._s(_vm.getGroupTitle))]),_c('div',{staticClass:"class-name"},[_vm._v(_vm._s(_vm.SelectedHeat.className))])]),_c('div',{staticClass:"icon",class:{
        'none': _vm.SelectedHeat.state == 0,
        'start-list': _vm.SelectedHeat.state == 1,
        'in-progress': _vm.SelectedHeat.state == 2,
        'finished': _vm.SelectedHeat.state == 3,
    }})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }